export default __webpack_public_path__ + "static/media/partner_logo_koer.1bb0b6fa.svg";